import React, { FC } from 'react'
import { ProductSchema } from '@moonpig/web-shared-products'
import { useProductContext } from '../../../contexts/product'
import { ProductModule } from '../types'
import { ProductModuleSection } from '../ProductModuleSection'

export const ProductSchemaModule: FC<ProductModule> = props => {
  const [{ product }] = useProductContext()
  const { id, title, description, masterVariant, rating, variants } = product
  return (
    <ProductModuleSection {...props}>
      <ProductSchema
        id={id}
        title={title}
        description={description}
        images={
          masterVariant.productImages?.images.map(
            image => image.large.jpgUrl,
          ) ?? []
        }
        rating={rating}
        offers={variants.map(({ sku, price, inStock }) => {
          const { centAmount, fractionDigits, currencyCode } = price
          return {
            sku: sku as string,
            price: (centAmount / 100).toFixed(fractionDigits),
            currencyCode,
            inStock,
          }
        })}
      />
    </ProductModuleSection>
  )
}
